import * as amplitude from '@amplitude/analytics-browser';
import { storageHelper, User } from '@spo/logic';
import { useEffect } from 'react';

export const daysName = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const useAmplitudeDayLog = () => {
  const user = storageHelper.getItem<User>('user');
  const day = daysName[new Date().getDay() - 1];

  useEffect(() => {
    if (user) {
      amplitude.logEvent('Day Log', {
        day,
      });
    }
  }, [user?.uid, day]);
};
